import React from 'react';
import { Link } from 'react-router-dom';

import { GAMES, PRACTICES } from '../../../config/constants';
import { isCC, isTA } from '../../../helpers';
import { useRouter } from '../../../helpers/customHooks';
import { useDataTeamsState, useUserState } from '../../../store/hooks';
import { TeamRoutes } from '../types';

const RadioPracticesGames = () => {
  
  const user = useUserState();
  const { dataTeam: team } = useDataTeamsState();
  const { match, location } = useRouter<TeamRoutes>();
  const { tab, event, id: teamId, conference } = match.params;
  
  if (isCC(user)) {
    return (
      <div className="r-left">
        <Link
          className="radio ll-oo"
          to={{
            pathname: `/team/${conference}/${teamId}/${tab}/practices`,
            state: {
              ...(location.state || {}),
              team: team ? team.team : null
            },
            search: location.search
          }}
        >
          <input id={tab + '-radio-practices'} type="radio" checked={event === PRACTICES} />
          <label htmlFor={tab + '-radio-practices'} className="radio-label capitalize-text">{PRACTICES}</label>
        </Link>
        <Link
          className="radio"
          to={{
            pathname: `/team/${conference}/${teamId}/${tab}/games`,
            state: {
              ...(location.state || {}),
              team: team ? team.team : null
            },
            search: location.search
          }}
        >
          <input id={tab + '-radio-games'} type="radio" checked={event === GAMES} />
          <label htmlFor={tab + '-radio-games'} className="radio-label capitalize-text">{GAMES}</label>
        </Link>
      </div>
    );
  }

  if (isTA(user)) {
    return (
      <div className="r-left">
        {team.teamId === user.teamId ? (
          <>
            <Link
              className="radio ll-oo"
              to={{
                pathname: `/team/${conference}/${teamId}/${tab}/practices`,
                state: {
                  ...(location.state || {}),
                  team: team ? team.team : null
                },
                search: location.search
              }}
            >
              <input id={tab + '-radio-practices'} type="radio" checked={event === PRACTICES} />
              <label htmlFor={tab + '-radio-practices'} className="radio-label capitalize-text">{PRACTICES}</label>
            </Link>
            <Link
              className="radio"
              to={{
                pathname: `/team/${conference}/${teamId}/${tab}/games`,
                state: {
                  ...(location.state || {}),
                  team: team ? team.team : null
                },
                search: location.search
              }}
            >
              <input id={tab + '-radio-games'} type="radio" checked={event === GAMES} />
              <label htmlFor={tab + '-radio-games'} className="radio-label capitalize-text">{GAMES}</label>
            </Link>
          </>
        ) : <label style={{ fontSize: '13px' }}>Showing Game Performance Only</label>}
      </div>
    );
  }
  
  return null;
};

export default RadioPracticesGames;
